import { render } from "./SubmitRetailerPopup.vue?vue&type=template&id=ff00df2e"
import script from "./SubmitRetailerPopup.vue?vue&type=script&lang=js"
export * from "./SubmitRetailerPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__